import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrFactSheetGroupComponent } from './kn-br-fact-sheet-group.component';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';

@NgModule({
    imports: [
        CommonModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBrFactSheetGroupComponent: {
                    component: KnBrFactSheetGroupComponent,
                },
            },
        } as CmsConfig),
        KnBrFactSheetGroupComponent,
    ],
})
export class KnBrFactSheetGroupModule {}
